import { css, cx } from "@emotion/css"

import COLOR_CODE from "../../../constant/color"
import Currency from "./Currency"

type Props = {
  className: string
  firstPrice: number | null
  initialCost: number | null
  manufactureCost: number | null
  repeatPrice: number | null
  unitPrice: number | null
}

const FirstPriceCell = ({ className, firstPrice, initialCost, manufactureCost, repeatPrice, unitPrice }: Props) => {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.currency}>
        <Currency amountClassName={styles.amount} currency={firstPrice} />
      </div>
      <div className={styles.bottomContent}>
        <div>
          イニシャル費用：
          <Currency currency={initialCost} />
        </div>
        <div>
          製造費用：
          <Currency currency={manufactureCost} />
        </div>
      </div>
      <div className={styles.repeatPrice}>
        リピート製造費用：
        <Currency currency={repeatPrice} />
        （単価
        <Currency currency={unitPrice} />）
      </div>
    </div>
  )
}

export default FirstPriceCell

const styles = {
  container: css`
    padding: 2px;
    padding-top: 0px;
    font-size: 13px;
  `,
  currency: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 39px;
    text-align: center;
  `,
  amount: css`
    font-size: 14px;
    font-weight: bold;
  `,
  bottomContent: css`
    min-height: 23px;
    line-height: 21px;
    text-align: center;
    background-color: ${COLOR_CODE.SIMULATION_CELL_GRAY};
  `,
  repeatPrice: css`
    line-height: 21px;
    text-align: center;
  `,
}
